/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'summarization-method-help',
  templateUrl: './summarization-method-help.component.html',
  styleUrls: ['./summarization-method-help.component.less'],
  standalone: false,
})
export class SummarizationMethodHelpComponent {

  constructor(public activeModal: NgbActiveModal) {
  }

}
